import styled from 'styled-components';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import socialShare from '@utils/socialShare';
import Facebook from '@icon/Facebook';
import Twitter from '@icon/Twitter';
import LinkedIn from '@icon/LinkedIn';
import {
  Spacings,
  Fonts,
  BorderColors,
  mobile
} from '../../../../styleConstants';
import SectionDescription from '../SectionDescription';
import SocialIcon from './SocialIcon';

const Wrapper = styled.div`
  border: 1px solid ${BorderColors.GREY};
  border-radius: ${Spacings.SPACING_2B};
  padding: ${Spacings.SPACING_3B} ${Spacings.SPACING_6B};
  margin-top: ${Spacings.SPACING_10B};
  display: inline-grid;
  grid-template: 1fr / repeat(4, max-content);
  grid-column-gap: ${Spacings.SPACING_2B};
  width: max-content;
  @media only screen and (max-width: ${mobile.maxWidth}) {
    margin-top: ${Spacings.SPACING_6B};
  }
`;

const VerticalRule = styled.div`
  width: 1px;
  height: ${Spacings.SPACING_6B};
  background-color: #dde6ed;
  margin: 0px ${Spacings.SPACING_2B};
`;

const socialIcons = [
  {
    name: 'facebook',
    icon: Facebook,
    color: '#3B5998'
  },
  {
    name: 'twitter',
    icon: Twitter,
    color: '#00ACEE'
  },
  {
    name: 'linkedin',
    icon: LinkedIn,
    color: '#0072B1'
  }
];

const socialShareHandlersMap = {
  [socialIcons[0].name]: () => () => {
    socialShare.shareToFB({
      url: window.location.href,
      title: 'Unacademy Summit 2020 | June 26, 27, 28'
    });
  },
  [socialIcons[1].name]: ({ twitterText }) => () => {
    socialShare.shareToTwitter({
      url: window.location.href,
      text: twitterText
    });
  }
};

const ShareContainer = ({ className, twitterText }) => {
  const staticTexts = useSelector(({ summit }) => summit.staticTexts || {});
  const twitterTxt = twitterText || staticTexts.defaultTwitterText || '';
  return (
    <Wrapper className={className}>
      <SectionDescription $size={Fonts.H6}>Share via</SectionDescription>
      <VerticalRule />
      {socialIcons.slice(0, 2).map((socialIcon) => (
        <SocialIcon
          key={socialIcon.name}
          socialIcon={socialIcon}
          onClick={socialShareHandlersMap[socialIcon.name]({
            twitterText: twitterTxt
          })}
        />
      ))}
    </Wrapper>
  );
};

ShareContainer.propTypes = {
  className: PropTypes.string,
  twitterText: PropTypes.string
};

ShareContainer.defaultProps = {
  className: '',
  twitterText: null
};

export default ShareContainer;
